import React from "react";
import { useAuth } from "../context/AuthContext";
import { Redirect, useLocation } from "react-router-dom";
import Loading from "../Loading";

const withAuthenticationRequired = (Component, { onRedirecting = () => <Loading /> } = {}) => {
  return function WrappedComponent(props) {
    const { isAuthenticated, loading } = useAuth();
    const location = useLocation();

    if (loading) return onRedirecting();

    if (!isAuthenticated) {
      return (
        <Redirect
          to={{
            pathname: "/login",
            state: { returnTo: location.pathname },
          }}
        />
      );
    }

    return <Component {...props} />;
  };
};

export default withAuthenticationRequired;